import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectMeteorologyFieldsModelPerformanceRounds,
  selectMeteorologyFieldsModelPerformanceRoundsRange,
  setFilter,
} from 'redux/reducers/meteorologyFieldsModelPerformanceReducer';
import { format, parse } from 'date-fns';

export default function usePresetRounds() {
  const rounds = useSelector(selectMeteorologyFieldsModelPerformanceRounds);
  const roundsRange = useSelector(selectMeteorologyFieldsModelPerformanceRoundsRange);

  // Para modo pré-definido, múltiplas rodadas podem ser selecionadas
  const selectedRounds = useMemo(() => {
    if (!rounds || !Array.isArray(rounds) || rounds.length === 0) return [];
    return rounds.map((roundStr) => parse(roundStr, 'yyyy-MM-dd', new Date()));
  }, [rounds]);

  const setSelectedRounds = useCallback((dates: Date[]) => {
    const roundStrings = dates.map((date) => date.toISOString().split('T')[0]);
    store.dispatch(setFilter({ rounds: roundStrings.length > 0 ? roundStrings : undefined }));
  }, []);

  // O intervalo sobrevive à troca de pêntada; só fica guardado quando está completo.
  const setRoundsRange = useCallback((start: Date | null, end: Date | null) => {
    store.dispatch(setFilter({
      roundsRange: start && end
        ? { start: format(start, 'yyyy-MM-dd'), end: format(end, 'yyyy-MM-dd') }
        : undefined,
    }));
  }, []);

  return {
    selectedRounds,
    setSelectedRounds,
    roundsRange,
    setRoundsRange,
  };
}
